import React from 'react'

export default function ReturnsPaymentBlock({
    retailer,
    retailerAddress,
    returnAttributes,
    casualUserAttributes,
    currentUser,
    totalPrice,
    isPrintInStore,
    error,
    onEditClick,
    paymentAction,
    isStoreComponents,
    isLockersComponents,
}) {
  return (
    <div>
        {error &&
          <div className="yodel-returns-error-message">
            <img src="/assets/yodel-assets/warning-triangle.svg" alt="error icon" />
            {error}
          </div>
        }
        <div className="retailer__show-return-details">
            <div className="retailer__show-returns-address">
            <div dangerouslySetInnerHTML={{ __html: retailerAddress.replace(/\r?\n/g, "<br>") }} />
            </div>

            <div className="retailer__show-pricing-breakdown">
                {(isPrintInStore || isLockersComponents) &&
                    <>
                        <div className="retailer__show-pricing-breakdown-row">
                            <span className="retailer__show-pricing-breakdown-name">
                                Retailer Price
                            </span>

                            <span className="retailer__show-pricing-breakdown-amount">
                                {`£${retailer.price?.toFixed(2)}`}
                            </span>
                        </div>

                        {isPrintInStore && (
                            <div className="retailer__show-pricing-breakdown-row">
                                <span className="retailer__show-pricing-breakdown-name">
                                    Print in Store
                                </span>

                                <span className="retailer__show-pricing-breakdown-amount">
                                    {`£${retailer.printInStorePrice?.toFixed(2)}`}
                                </span>
                            </div>
                        )}
                    </>
                }
                

                <div className="retailer__show-pricing-breakdown-row">
                    <span className="retailer__show-pricing-breakdown-name">
                        TOTAL PRICE
                    </span>

                    <span className="retailer__show-pricing-breakdown-amount">
                        {`£${totalPrice.toFixed(2)}`}
                    </span>
                </div>
            </div>
        </div>

        <div className="retailer__show-confirm-payment">
            <div className="retailer__confirm-payment-email">
            <strong>{"Your email: "}</strong>
            { `${currentUser?.email || casualUserAttributes?.email} `}
            {!currentUser &&
                <a href=""
                   onClick={(e) => {
                    e.preventDefault();
                    onEditClick();
                   }}>
                    Edit
                </a>
            }
            </div>

            <div className="retailer__submit-payment-form">
                <input 
                    className="yodel-outline-button"
                    type="button"
                    defaultValue="Confirm & Pay"
                    onClick={(e) => {
                        e.preventDefault();
                        paymentAction(returnAttributes, casualUserAttributes, totalPrice);
                    }}/>
            </div>
        </div>
    </div>
  )
}
